import { t } from 'i18next';

export const RECENT_ACCESS_SAVE = true;
export const RECENT_ACCESS_KEY = {
    HOME:"HOME",
    DASHBOARD:"DASHBOARD",
    DAS_REQUEST_SUM:"DAS_REQUEST_SUM",
    DAS_ASSET_SUM:"DAS_ASSET_SUM",
    DAS_SETTLEMENT_SUM:"DAS_SETTLEMENT_SUM",
    DAS_SLA_SUM:"DAS_SLA_SUM",
    DAS_REPORT_SUM:"DAS_REPORT_SUM",
    ACCOUNT_SETTING:"ACCOUNT_SETTING",
    REQUEST:"REQUEST",
    REQUEST_LIST:"REQUEST_LIST",
    CONTAINER_LIST:"CONTAINER_LIST",
    ASSET_LIST:"ASSET_LIST",
    REC_REQUEST_LIST:"REC_REQUEST_LIST",
    REQUEST_DETAIL:"REQUEST_DETAIL",
    DOCUMENT:"DOCUMENT",
    DOC_STANDARD:"DOC_STANDARD",
    DOC_SERVICE:"DOC_SERVICE",
    DOC_OTHER:"DOC_OTHER",
    SUPPORT:"SUPPORT",
    CONTACT_US:"CONTACT_US",
    CONTACT_US_OPEN_INQ:"CONTACT_US_OPEN_INQ",
    CONTACT_US_COMPLETE_INQ:"CONTACT_US_COMPLETE_INQ",
    CONTACT_US_ACCESS_LIST:"CONTACT_US_ACCESS_LIST",
    NOTICE:"NOTICE",
    FAQ:"FAQ",
    NOTICE_DETAIL:"NOTICE_DETAIL",
    INQUIRY_DETAIL:"INQUIRY_DETAIL",
    ACCESS_DETAIL: "ACCESS_DETAIL",
    NEW_INQUIRY:"NEW_INQUIRY",
    SETTING:"SETTING",
    MASTER_DATA:"MASTER_DATA",
    MASTER_DATA_TAB_COMPANY:"MASTER_DATA_TAB_COMPANY",
    MASTER_DATA_TAB_COLLECTIONSITE:"MASTER_DATA_TAB_COLLECTIONSITE",
    USER_MNG:"USER_MNG",
    USER_MNG_TAB_UGROUP:"USER_MNG_TAB_UGROUP",
    USER_MNG_TAB_USER:"USER_MNG_TAB_USER",
    USER_MNG_TAB_USER_UNAPPROVE_LIST:"USER_MNG_TAB_USER_UNAPPROVE_LIST",
    NEWREQUEST:"NEWREQUEST",
    USER:"USER",
    REQUEST_SUMMARY:"REQUEST_SUMMARY",
    IMPORT_REQUEST:"IMPORT_REQUEST",
    CONTAINER_DASHBOARD:"CONTAINER_DASHBOARD",
    RECURSIVE_REQUEST:"RECURSIVE_REQUEST",
    ASSETS_QUEUE:"ASSETS_QUEUE",
    REQUEST_DOC:"REQUEST_DOC",
    COLLECTION_ADDRESS:"COLLECTION_ADDRESS",
    COMPANIES:"COMPANIES",
    REPORT:"REPORT",
    VIZ_REPORT:"VIZ_REPORT",
    PORTAL_DOC:"PORTAL_DOC"
}
export const RECENT_ACCESS_PART = {
    HOME: {
        name:t(`SideMenu.Home`),
        part:"/dashboard/home",
        tab:""
    },
    DASHBOARD: {
        name:t(`SideMenu.DashBoard`),
        part:"/dashboard/basic",
        tab:""
    },
    DAS_REQUEST_SUM: {
        name:t(`SideMenu.RequestSummary`),
        part:"/dashboard/basic/request-summary",
        tab:"tabreq"
    },
    DAS_ASSET_SUM: {
        name:t(`SideMenu.AssetSummary`),
        part:"/dashboard/basic/asset-summary",
        tab:"tabasset"
    },
    DAS_SETTLEMENT_SUM: {
        name:t(`SideMenu.SettlementSummary`),
        part:"/dashboard/basic/settlement-summary",
        tab:"tabsettlement"
    },
    DAS_SLA_SUM: {
        name:t(`SideMenu.SLASummary`),
        part:"/dashboard/basic/sla-summary",
        tab:"tabsla"
    },
    DAS_REPORT_SUM: {
        name:t(`SideMenu.CustomizedReports`),
        part:"/dashboard/basic/customized-reports",
        tab:"tabreport"
    },
    ACCOUNT_SETTING: {
        name:t(`SideMenu.AccountSetting`),
        part:"/dashboard/account-setting",
        tab:""
    },
    REQUEST_ACCESS: {
        name:t(`SideMenu.RequestAccess`),
        part:"/dashboard/request-access",
        tab:""
    },
    REQUEST: {
        name:t(`SideMenu.ServiceRequest`),
        part:"/dashboard/service-request",
        tab:""
    },
    REQUESTS: {
        part:"/dashboard/requests",
        tab:""
    },
    REQUEST_LIST: {
        name:t(`SideMenu.RequestList`),
        part:"/dashboard/service-request/request-list",
        tab:"tabrequest"
    },
    CONTAINER_LIST: {
        name:t(`SideMenu.ContainerList`),
        part:"/dashboard/service-request/container-list",
        tab:"tabcontainer"
    },
    ASSET_LIST: {
        name:t(`SideMenu.AssetList`),
        part:"/dashboard/service-request/asset-list",
        tab:"tabasset"
    },
    REC_REQUEST_LIST: {
        name:t(`SideMenu.RecursiveRequestList`),
        part:"/dashboard/service-request/recursive-request-list",
        tab:"tabrecursive"
    },
    REQUEST_DETAIL: {
        name:t(`SideMenu.RequestDetail`),
        part:"/dashboard/requests/",
        tab:""
    },
    DOCUMENT: {
        name:t(`SideMenu.Document`),
        part:"/dashboard/documents",
        tab:""
    },
    DOC_STANDARD: {
        name:t(`SideMenu.StandardReports`),
        part:"/dashboard/documents",
        tab:"tabstandard"
    },
    DOC_SERVICE: {
        name:t(`SideMenu.ServiceDocuments`),
        part:"/dashboard/documents/service-documents",
        tab:"tabservice"
    },
    DOC_OTHER: {
        name:t(`SideMenu.OtherDocuments`),
        part:"/dashboard/documents/other-documents",
        tab:"tabother"
    },
    SUPPORT: {
        name:t(`SideMenu.Support`),
        part:"/dashboard/support",
        tab:""
    },
    CONTACT_US: {
        name:t(`SideMenu.ContactUs`),
        part:"/dashboard/support/contact-us",
        tab:"tabcontact"
    },
    CONTACT_US_OPEN_INQ: {
        name:t(`SideMenu.Openinq`),
        part:"/dashboard/support/contact-us/open-inquiries",
        tab:"tabcontact/openinq"
    },
    CONTACT_US_COMPLETE_INQ: {
        name:t(`SideMenu.Completeinq`),
        part:"/dashboard/support/contact-us/completed-inquiries",
        tab:"tabcontact/completeinq"
    },
    CONTACT_US_ACCESS_LIST: {
        name:t(`SideMenu.AccessRequest`),
        part:"/dashboard/support/contact-us/access-requests",
        tab:"tabcontact/accessrequest"
    },
    NOTICE: {
        name:t(`SideMenu.Notice`),
        part:"/dashboard/support/notice",
        tab:"tabnotice"
    },
    FAQ: {
        name:t(`SideMenu.FAQ`),
        part:"/dashboard/support/faq",
        tab:"tabfaq"
    },
    NOTICE_DETAIL: {
        name:t(`SideMenu.NoticeDetail`),
        part:"/dashboard/support/notice-detail/",
        tab:""
    },
    INQUIRY_DETAIL: {
        name:t(`SideMenu.InquiryDetail`),
        part:"/dashboard/support/inquiry-detail/",
        tab:""
    },
    ACCESS_DETAIL: {
        name:t(`SideMenu.AccessDetail`),
        part:"/dashboard/support/access-detail/",
        tab:""
    },
    NEW_INQUIRY: {
        name:t(`SideMenu.NewDetail`),
        part:"/dashboard/support/new-inquiry",
        tab:""
    },
    SETTING: {
        name:t(`SideMenu.Setting`),
        part:"/dashboard/setting",
        tab:""
    },
    MASTER_DATA: {
        name:t(`SideMenu.Masterdata`),
        part:"/dashboard/setting/master-data",
        tab:"tabmaster"
    },
    MASTER_DATA_TAB_COMPANY: {
        name:t(`SideMenu.Tabcompany`),
        part:"/dashboard/setting/master-data/companies",
        tab:"tabmaster/tabcompany"
    },
    MASTER_DATA_TAB_COLLECTIONSITE: {
        name:t(`SideMenu.Collectionsite`),
        part:"/dashboard/setting/master-data/collection-site",
        tab:"tabmaster/tabcollectionsite"
    },
    USER_MNG: {
        name:t(`SideMenu.UserManagement`),
        part:"/dashboard/setting/user-management",
        tab:"tabusermng"
    },
    USER_MNG_TAB_UGROUP: {
        name:t(`SideMenu.Tabugroup`),
        part:"/dashboard/setting/user-management/user-group",
        tab:"tabusermng/tabugroup"
    },
    USER_MNG_TAB_USER: {
        name:t(`SideMenu.Tabuser`),
        part:"/dashboard/setting/user-management/user-list",
        tab:"tabusermng/tabuser"
    },
    USER_MNG_TAB_USER_UNAPPROVE_LIST: {
        name:t(`SideMenu.Tabuser`),
        part:"/dashboard/setting/user-management/dealerapproval",
        tab:"tabusermng/dealerapproval"
    },
    NEWREQUEST: {
        name:t(`SideMenu.NewRequest`),
        part:"/dashboard/requests/new-request",
        tab:""
    },
    USER: {
        name:t(`SideMenu.Users`),
        part:"/dashboard/user",
        tab:""
    },
    REQUEST_SUMMARY: {
        name:t(`SideMenu.RequestSummary`),
        part:"/dashboard/requestsummary",
        tab:""
    },
    IMPORT_REQUEST: {
        name:t(`SideMenu.ImportRequest`),
        part:"/dashboard/import-request",
        tab:""
    },
    CONTAINER_DASHBOARD: {
        name:t(`SideMenu.ContainerDashboard`),
        part:"/dashboard/pallets",
        tab:""
    },
    RECURSIVE_REQUEST: {
        name:t(`SideMenu.RecursiveRequest`),
        part:"/dashboard/recursiveRequest",
        tab:""
    },
    ASSETS_QUEUE: {
        name:t(`SideMenu.AssetsQueue`),
        part:"/dashboard/assetsqueue",
        tab:""
    },
    REQUEST_DOC: {
        name:t(`SideMenu.RequestDocs`),
        part:"/dashboard/requestdoc",
        tab:""
    },
    COLLECTION_ADDRESS: {
        name:t(`SideMenu.CollectionAddress`),
        part:"/dashboard/collectionAddress",
        tab:""
    },
    COMPANIES: {
        name:t(`SideMenu.Companies`),
        part:"/dashboard/companies",
        tab:""
    },
    REPORT: {
        name:t(`SideMenu.Reports`),
        part:"/dashboard/reports",
        tab:""
    },
    VIZ_REPORT: {
        name:t(`SideMenu.VisualizationReports`),
        part:"/dashboard/vizreports",
        tab:""
    },
    PORTAL_DOC: {
        name:t(`SideMenu.PortalDocs`),
        part:"/dashboard/portaldocs",
        tab:""
    }
}